/** Figma `Card` 세트(Components, 7:184)의 축 */
export const CARD_SHADOWS = ['default', 'accent', 'strong', 'none'] as const;
/**
 * Figma `shadow`. default = 보통 카드, accent = 청록 그림자 — 기업(PF)에게도 공개되는 영역임을 알린다,
 * strong = 인증 화면 카드, none = 그림자 없음 — 그림자 없는 이웃 구획(요약 · 투자 카드 등)과 나란히 놓일 때
 */
export type CardShadow = (typeof CARD_SHADOWS)[number];

export const CARD_STATUSES = ['default', 'init'] as const;
export type CardStatus = (typeof CARD_STATUSES)[number];

/** 흰 면 · 모서리 12. 여백 · 내용 사이 간격은 `CARD_PADDING_CLASS` · `CARD_GAP_CLASS` */
export const CARD_BASE_CLASS = 'flex flex-col rounded-2xl bg-bg-surface';

/** 안쪽 여백(사방). 기본 md 20(Figma). 위아래 · 좌우가 다르면 `className` 으로 덮는다(`py-3` 등) */
export const CARD_PADDINGS = ['none', 'sm', 'md', 'lg', 'xl'] as const;
export type CardPadding = (typeof CARD_PADDINGS)[number];

export const CARD_PADDING_CLASS: Record<CardPadding, string> = {
  none: 'p-0',
  sm: 'p-4',
  md: 'p-5',
  lg: 'p-6',
  xl: 'p-8',
};

/** 내용 사이 간격(세로). 기본 md 16(Figma) */
export const CARD_GAPS = ['none', 'sm', 'md', 'lg'] as const;
export type CardGap = (typeof CARD_GAPS)[number];

export const CARD_GAP_CLASS: Record<CardGap, string> = {
  none: 'gap-0',
  sm: 'gap-2-5',
  md: 'gap-4',
  lg: 'gap-5',
};

export const CARD_SHADOW_CLASS: Record<CardShadow, string> = {
  default: 'shadow-card',
  accent: 'shadow-card-accent',
  strong: 'shadow-card-strong',
  none: 'shadow-none',
};
